import { render, staticRenderFns } from "./InstrumentList.vue?vue&type=template&id=64ac70ba&scoped=true&"
import script from "./InstrumentList.vue?vue&type=script&lang=js&"
export * from "./InstrumentList.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentList.vue?vue&type=style&index=0&id=64ac70ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac70ba",
  null
  
)

export default component.exports